import { render, staticRenderFns } from "./rulePage.vue?vue&type=template&id=7b8b8728&"
import script from "./rulePage.vue?vue&type=script&lang=js&"
export * from "./rulePage.vue?vue&type=script&lang=js&"
import style0 from "./rulePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports